import { type ReactElement } from 'react';
import styles from './button-remake.module.scss';

import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { Link } from '../link/link';
import { Font } from '../text/font';
import { IconsEnum } from '@utmb/types/icons';
import { Icon } from '../icons/Icon';

export interface ButtonRemakeProps {
    variant: 'solid' | 'transparent' | 'link';
    label: string;
    action: string | (() => void);
    icon?: IconsEnum;
    customClassName?: string;
    target?: '_self' | '_blank';
}

const ButtonContent = ({ icon, variant, label }: { variant: 'solid' | 'transparent' | 'link'; label: string; icon?: IconsEnum }) => (
    <>
        {icon ? <Icon variant={icon} width={22} height={22} color={getColorStyle(ColorTypesEnum.PRIMARY)} /> : null}
        {variant === 'transparent' ? (
            <Font.FuturaMedium className={styles.label} color={getColorStyle(ColorTypesEnum.PRIMARY)} as="span" desktop="16" mobile="16">
                {label}
            </Font.FuturaMedium>
        ) : variant === 'link' ? (
            <Font.FuturaMedium className={styles.label} color={getColorStyle(ColorTypesEnum.WHITE)} as="span" desktop="14" mobile="14">
                {label}
            </Font.FuturaMedium>
        ) : (
            <Font.FuturaBold className={styles.label} color={getColorStyle(ColorTypesEnum.PRIMARY)} as="span" desktop="14" mobile="14">
                {label}
            </Font.FuturaBold>
        )}
    </>
);

export function ButtonRemake({ variant, label, action, icon, customClassName, target }: ButtonRemakeProps): ReactElement {
    if (typeof action === 'string') {
        return (
            <Link className={`${styles.buttonRemake} ${styles[variant]} ${customClassName ?? ''}`} href={action} target={target ? target : '_self'}>
                <ButtonContent label={label} variant={variant} icon={icon} />
            </Link>
        );
    }

    return (
        <button className={`${styles.buttonRemake} ${styles[variant]} ${customClassName ?? ''}`} onClick={action}>
            <ButtonContent label={label} variant={variant} icon={icon} />
        </button>
    );
}
